/**
 * تاریخ شمسی بدون کتابخانه: تبدیل میلادی ← شمسی از خودِ Intl مرورگر، و
 * شمسی ← میلادی با جست‌وجوی کوتاه روی همان Intl. پس هر دو جهت دقیقاً با
 * تقویمی که مرورگر نشان می‌دهد یکی‌اند (سرور هم با همین تقویم سنجیده شده —
 * api/jalali.py).
 */

import { toIsoDate } from './format';

export const MONTH_NAMES = [
  'فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور',
  'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند',
];

const persian = new Intl.DateTimeFormat('en-US-u-ca-persian', {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
});

/** Date ← {year, month, day} شمسی. */
export function toJalali(date) {
  const parts = Object.fromEntries(
    persian.formatToParts(date).map((part) => [part.type, part.value])
  );
  return { year: Number.parseInt(parts.year, 10), month: Number(parts.month), day: Number(parts.day) };
}

const key = ({ year, month, day }) => year * 10000 + month * 100 + day;

/** {year, month, day} شمسی ← Date (ظهرِ وقت محلی، تا تغییر ساعت روز را جابه‌جا نکند). */
export function fromJalali(year, month, day) {
  const target = key({ year, month, day });
  // نوروز حدود ۲۱ مارس سالِ year+621 است؛ از تخمین شروع و روزبه‌روز اصلاح می‌کنیم.
  const guess = new Date(year + 621, 2, 21, 12);
  guess.setDate(guess.getDate() + Math.round((month - 1) * 30.4) + (day - 1));
  for (let i = 0; i < 60; i += 1) {
    const current = key(toJalali(guess));
    if (current === target) return guess;
    guess.setDate(guess.getDate() + (current < target ? 1 : -1));
  }
  return null;
}

export function daysInMonth(year, month) {
  if (month <= 6) return 31;
  if (month <= 11) return 30;
  const day30 = fromJalali(year, 12, 30);
  return day30 && toJalali(day30).month === 12 ? 30 : 29;
}

/** «۱۴۰۵/۰۸/۰۲» برای نمایش کوتاه. */
export function formatJalali(value) {
  if (!value) return '—';
  return new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' })
    .format(new Date(value));
}

/** [اول، آخرِ] ماه شمسی‌ای که offset ماه با ماه جاری فاصله دارد، به شکل ISO. */
export function jalaliMonthRange(offset = 0, reference = new Date()) {
  const today = toJalali(reference);
  let month = today.month + offset;
  let year = today.year;
  while (month < 1) { month += 12; year -= 1; }
  while (month > 12) { month -= 12; year += 1; }
  return {
    from: toIsoDate(fromJalali(year, month, 1)),
    to: toIsoDate(fromJalali(year, month, daysInMonth(year, month))),
    label: `${MONTH_NAMES[month - 1]} ${new Intl.NumberFormat('fa-IR', { useGrouping: false }).format(year)}`,
  };
}
